export enum AssessedBy {
  serviceProvider = 'serviceProvider',
  primeContractor = 'primeContractor',
  CEC = 'CEC',
}
